/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createOrUpdateGreetingModelSchema } from "../createOrUpdateGreetingModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

export const putApiGreetingsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор экрана")
    })

/**
 * @description Идентификатор обновляемого шаблона
 */
export const putApiGreetingsId200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Шаблон приветственного экрана уже существует | Ошибка валидации
 */
export const putApiGreetingsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiGreetingsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiGreetingsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Шаблон приветственного экрана не найден
 */
export const putApiGreetingsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiGreetingsId500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const putApiGreetingsIdMutationRequestSchema = z.lazy(() => createOrUpdateGreetingModelSchema).describe("Тело запроса")

export const putApiGreetingsIdMutationResponseSchema = z.lazy(() => putApiGreetingsId200Schema)